<template>
  <div>
    <!--审批人/抄送人-->
    <el-dialog
      title="添加抄送人"
      :visible.sync="ccToCorpUserVisible"
      width="50%"
    >
      <el-row class="tel-search">
        <el-col :span="20">
          <el-row>
            <el-col :span="8" style="padding: 0 10px">
              <el-input
                clearable
                v-model="myCorpModel.keyword"
                @keyup.enter.native="queryToolMyCorp()"
                size="small"
                placeholder="账号"
              />
            </el-col>
            <el-col :span="8" style="padding: 0 10px">
              <el-input
                clearable
                v-model="myCorpModel.corpUserName"
                size="small"
                placeholder="名称"
              ></el-input>
            </el-col>
            <el-col :span="8" style="padding: 0 10px">
              <el-select
                v-model="myCorpModel.corpGroupId"
                placeholder="请选择部门"
                size="small"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="(item, i) in department"
                  :key="i"
                  :label="item.groupName"
                  :value="item.corpGroupId"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="3" :push="1" style="text-align:end;">
          <el-button @click="queryToolMyCorp()" size="small" class="btn"
            >查询</el-button
          >
        </el-col>
      </el-row>

      <div class="tel-box" style="height: 415px; overflow: auto">
        <el-table
          ref="singleTableRef"
          v-loading="myCorpModel.loading"
          :empty-text="myCorpModel.emptyText"
          @row-click="handleRowClickAuditAndCopy"
          :data="tableListMyCorp"
          style="width: 100%"
          highlight-current-row
          tooltip-effect="dark"
          stripe
          :cell-style="{ cursor: 'pointer' }"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500'
          }"
        >
          <el-table-column label="账号" prop="targetId" />
          <el-table-column label="名称" prop="userName" />
          <el-table-column label="部门" prop="groupNames" />
        </el-table>
      </div>
      <br />
      <el-pagination
        @size-change="handleSizeChangeQueryToolMyCorp"
        @current-change="handleCurrentChangeQueryToolMyCorp"
        :current-page="myCorpModel.itemPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="myCorpModel.pageSize"
        layout="sizes, prev, pager, next, jumper, total"
        :total="myCorpModel.total"
        style="text-align: right"
      />
      <p slot="footer" class="dialog-footer">
        <el-button @click="ccToCorpUserVisible = false" size="small" class="btn"
          >取消</el-button
        >
        <el-button
          @click="clickHandleAddAuditorOrCopyerSubmit()"
          type="danger"
          size="small"
          class="btn"
          >添加</el-button
        >
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
export default {
  name: "index",
  props: {
    applyNosArr: {
      type: Array
    }
  },
  data() {
    return {
      ccToCorpUserVisible: false,
      myCorpModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", // 名称
        corpGroupId: "" // 部门ID
      },
      department: [],
      tableAuditAndCopySelectRow: {},
      tableListMyCorp: []
    };
  },
  mounted() {
    this.queryToolMyCorp();
  },
  methods: {
    show() {
      this.ccToCorpUserVisible = true;
    },
    // 添加审批人抄送人table row click event
    handleRowClickAuditAndCopy(row, event, column) {
      this.tableAuditAndCopySelectRow = row;
    },
    // 查询我的组织 签署人列表
    queryToolMyCorp() {
      this.myCorpModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      // if (!this.myCorpModel.keyword) {
      this.myCorpModel.targetId = this.myCorpModel.keyword;
      ApiCorpMethods.CorpCommonController.listCorpUser(this.myCorpModel)
        .then(res => {
          this.myCorpModel.loading = false;
          if (res.code === "0") {
            this.tableListMyCorp = res.data;
            this.myCorpModel.total = res.total;
            if (res.total === 0) {
              this.myCorpModel.emptyText = "暂无数据";
            }
          } else {
            this.tableListMyCorp = [];
            this.myCorpModel.total = 0;
            this.myCorpModel.emptyText = res.description;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.myCorpModel.loading = false;
          this.tableListMyCorp = [];
          this.myCorpModel.total = 0;
          this.myCorpModel.emptyText = res.description;
          this.$message.error(err.description);
        });
    },
    handleSizeChangeQueryToolMyCorp(val) {
      this.myCorpModel.itemPage = 1;
      this.myCorpModel.pageSize = val;
      this.queryToolMyCorp();
    },
    handleCurrentChangeQueryToolMyCorp(val) {
      this.myCorpModel.itemPage = val;
      this.queryToolMyCorp();
    },
    // 添加抄送人
    clickHandleAddAuditorOrCopyerSubmit() {
      if (!this.tableAuditAndCopySelectRow) {
        this.$message.error("请选择抄送人");
      } else {
        let param = {
          applyNos: this.applyNosArr.join(","),
          corpUserIds: this.tableAuditAndCopySelectRow.corpUserIdSec
        };
        ApiCorpMethods.CorpCommonController.ccToCorpUSerList(param).then(
          res => {
            if (!res.success) {
              return this.$message.error(res.description || res.msg);
            } else {
              this.$refs.singleTableRef.setCurrentRow();
              this.tableAuditAndCopySelectRow = "";
              this.$message.success("添加抄送成功");
              this.ccToCorpUserVisible = false;
              this.$emit("clearListFn");
            }
          }
        );
      }
    }
  }
};
</script>

<style lang="less">
.tel-box {
  margin-top: 20px;
  .el-table__row.current-row {
    color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// components/selectCcUser/index.vue